import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _TimeLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("circle", { cx: 12, cy: 12, r: 8.5, stroke: "currentColor" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M16.5 12h-4.25a.25.25 0 0 1-.25-.25V8.5" })));
}
const TimeLight = forwardRef(_TimeLight);
export { TimeLight };
